import { render, staticRenderFns } from "./editEdition.vue?vue&type=template&id=1c9bf149"
import script from "./editEdition.vue?vue&type=script&lang=js"
export * from "./editEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports